export const createAudioBufferFromLPCM = ({
  arrayBuffer,
  numChannels,
  sampleRate,
  context,
}: {
  arrayBuffer: ArrayBuffer;
  numChannels: number;
  sampleRate: number;
  context: AudioContext;
}): AudioBuffer => {
  const audioBuffer = context.createBuffer(
    numChannels,
    arrayBuffer.byteLength / 2, // 16 бит = 2 байта
    sampleRate
  );

  const data = new Int16Array(arrayBuffer);

  for (let channel = 0; channel < numChannels; channel++) {
    const channelData = audioBuffer.getChannelData(channel);
    for (let i = 0; i < data.length; i++) {
      channelData[i] = data[i] / 32768.0; // Конвертируем в float [-1..1]
    }
  }

  return audioBuffer;
};
